export const SEGMENTATION_PROCESSING_PHASE = {
  starting: 'Preparing segmentation',
  extractTeeth: 'Extracting teeth from jaw mesh',
  refineProximal: 'Refining interdental surfaces',
  gumMesh: 'Building gum mesh',
  smoothGum: 'Smoothing gum boundary',
  snapGum: 'Aligning gum with teeth',
  papilla: 'Finding papilla anchors',
  fillTeeth: 'Filling tooth surfaces',
  fillTooth: (index: number, total: number) => `Filling tooth ${index + 1} of ${total}`,
  gumBridges: 'Connecting interdental gum',
  exporting: 'Exporting mesh data',
} as const;

export const SEGMENTATION_UPLOAD_PHASE = 'Uploading segmentation to server';
